<template>
    <div class="mission-item" @click="clickToDetail()">
        <div class="wrapper-img">
            <div class="img">
                <img :src="`${pictureUrl}${missionInfo.image}`"/>
            </div>
        </div>
        <div class="detail">
            <div class="text-name">{{missionInfo.l_title}}</div>
            <div class="text-detail">{{missionInfo.l_description}}</div>
            <div class="wrapper-point" v-if="missionInfo.point > 0">
                <div class="box-point">
                    <div class="text-get">{{lbl.mission.get}}</div>
                    <div class="mission-point">
                        <div class="text">
                        <span class="use-point">{{missionInfo.point | number_format}}</span>
                            <span>
                                <img class="icon-point" src="@/assets/icon/reward_icon_coin@3x.png" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-detail-more" v-if="missionInfo.l_description_2nd">
                {{missionInfo.l_description_2nd}}
            </div>
            <div class="box-success" v-if="isSuccess">
                <img src="../../../assets/icon/ic-check-green.png"/> สำเร็จแล้ว
            </div>
        </div>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: 'MissionItem',
    props:{
        lbl: Object,
        mission: Object,
    },
    data: function(){
        return {
            missionType: '',
            missionInfo: null,
            pictureUrl: ConfigManager.getBlobUrl() + '/config/bioderma/mission/',
            isSuccess: false,
            isCheckSuccess: false,
            isClick: true,
        }
    },
    created: function(){
        this.initialMissionType();

        if(this.mission.CustomInfo){
            this.missionInfo = JSON.parse(this.mission.CustomInfo);
        }
        //console.log('mission', JSON.parse(this.mission.CustomInfo))
    },
    methods: {
        initialMissionType: function(){
            if(this.mission.PartitionKey.indexOf("BiodermaCoupon") >= 0){
                if(this.mission.PartitionKey.indexOf("BiodermaCoupon4") >= 0){
                    this.missionType = 'coupon4';
                    this.isCheckSuccess = true;
                }else if(this.mission.PartitionKey.indexOf("BiodermaCoupon6") >= 0){
                    this.missionType = 'coupon6';
                    this.isCheckSuccess = true;
                }

            }
            else if(this.mission.PartitionKey.indexOf("Bioderma_CheckIn7day") >= 0){
                this.missionType = 'checkin';
                this.isCheckSuccess = true;
            } 
            else{
                switch (this.mission.PartitionKey){
                    // case 'BiodermaCoupon4_23213185':
                    //     this.missionType = 'coupon4';
                    //     this.isCheckSuccess = true;
                    //     break;
                    // case 'BiodermaCoupon6_23121751':
                    //     this.missionType = 'coupon6';
                    //     this.isCheckSuccess = true;
                    //     break;
                    // case 'BiodermaCoupon6_Starbuck':
                    //     this.missionType = 'coupon6';
                    //     this.isCheckSuccess = true;
                    //     break;
                    case 'BiodermaInvitor':
                        this.missionType = 'getfriend';
                        this.isCheckSuccess = false;
                        break;
                    case 'BiodermaAds':
                        this.missionType = 'survey';
                        this.isCheckSuccess = false;
                        break;
                    case 'BiodermaAds_draw':
                        this.missionType = 'surveydraw';
                        this.isCheckSuccess = false;
                        break;
                    case 'BiodermaApproveSurvey':
                        this.missionType = 'review';
                        this.isCheckSuccess = false;
                        break;
                    case 'BiodermaUpdateProfile':
                        this.missionType = 'update-profile';
                        this.isCheckSuccess = true;
                        break;
                    default:
                        this.missionType = '';
                        this.isCheckSuccess = false;
                        break;
                }
            }

            if(this.isCheckSuccess) this.checkMissionSuccess();
        },
        checkMissionSuccess: function(){
            //check success
            var allItem = this.mission.Missions[0].Value;
            var productCollect = this.mission.Missions[0].Current;

            if(allItem == productCollect || this.mission.Missions[0].IsCompleted){
                this.isSuccess = true;
            }
        },
        clickToDetail: function(){
            if(!this.missionType) return;
            if(this.missionType == 'update-profile' && this.isSuccess) return;

            this.$router.push("/mission/" + this.missionType);
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";

.mission-item{
    @extend %display-flex;
    background-color: $bg-color;
    border-radius: 10px;
    padding: 12px 10px;
    margin: 10px 0;
    min-height: 190px;

    .wrapper-img{
        flex: 0 0 40%;
        width: 40%;
        .img{
            @include baseRatioImg();
            border-radius: 10px;
        }
    }

    .detail{
        flex: 0 0 60%;
        width: 60%;
        font-size: 1.125rem;
        line-height: 1.2;
        padding-left: 15px;
        position: relative;

        @include mini-mobile(){
            font-size: 1rem;
        }

        .text-name{
            @extend %ellipsis-2;
            color: $black;
            font-family: $medium;
        }
        .text-detail{
            @extend %ellipsis-2;
            color: $bright-gray;
            padding-top: 5px;
        }
        .wrapper-point{
            padding-top: 8px;
            .box-point{
                @extend %display-flex;
                width: fit-content;
                align-items: center;

                .text-get{
                    font-family: $medium;
                    font-size: 1.12rem;
                    color: $blue-gray;
                    padding-right: 7px;
                }
                .mission-point{
                    flex: 0 0 80px;
                    width: 80px;
                    height: 33px;
                    position: relative;
                    font-size: 1.8rem;
                    padding: 1px 2px 1px 12px;
                    border-radius: 30px;
                    background-color: $blue-gray;
                    margin: auto;
                    .text {
                        @extend %display-flex;
                        width: 100%;

                        .use-point {
                            flex: 0 0 59%;
                            width: 59%;
                            margin-top: 8px;
                            font-family: $medium;
                            font-size: 1.12rem;
                            line-height: 1;
                            text-align: left;
                            color: $white;

                            @include mini-mobile() {
                                font-size: 1rem;
                            }
                        }
                        .icon-point {
                            flex: 0 0 35%;
                            width: 25px;
                            margin-top: -5px;

                            @include mini-mobile() {
                                flex: 0 0 43%;
                                width: 20px;
                            }
                        }
                    }
                }
            }
        }
        .text-detail-more{
            color: $bright-gray;
            padding-top: 20px;
        }
        .box-success{
            color: $green;
            font-size: 1.12rem;
            padding-top: 20px;
            // position: absolute;
            // bottom: 0;

            @include mini-mobile(){
                font-size: 1rem;
            }

            img{
                width: 18px;
            }
        }
    }
}
</style>
